import { useState } from 'react';
import {
  faStar,
  faCartShopping,
  faComment,
  faPhotoFilm,
  faSparkles,
  faGift,
  faAward,
} from '@fortawesome/pro-solid-svg-icons';
import { Col, Row } from 'react-bootstrap';
import TabButton from '../TabButton/TabButton';
import Feedback from './Feedback/Feedback';
import Highlight from './Highlight/Highlight';
import MediaCenter from './MediaCenter/MediaCenter';
import Video from './Video/Video';
import NewProduct from './NewProduct/NewProduct';
import Samples from './Samples/Samples';
import { IVtsExhibitor } from '../../Main/Admin/Exhibitors/Exhibitors';
import styles from './ExhibitorPopup.module.scss?module';
import LogoImage from '../../../../Abstracts/LogoImage/LogoImage';
import Modal1 from '../../../../Abstracts/Modal1/Modal1';
import LoadingSpinner from '../../../../Abstracts/LoadingSpinner/LoadingSpinner';
import AwardYearAwardCategories from '../../../../Abstracts/AwardYearAwardCategories/AwardYearAwardCategories';
import { TAB_STATES } from '../../Main/Exhibition/ExhibitorBoothPopup/ExhibitorBoothPopup';
import ProductsFilterProvider from '../../../../Context/ProductsFilterContext';
import VtsProducts from './VtsProducts/VtsProducts';
import { ProductListProvider } from '../../../../Context/ProductListContext';
// import Awards from './Awards/Awards';

export default function ExhibitorPopup({
  exhibitor,
  isOpen,
  onClose,
  exhibitor_tab,
  scrollIntoViewProductSize_Id,
}: {
  exhibitor?: IVtsExhibitor;
  isOpen: boolean;
  onClose: () => void;
  exhibitor_tab?: TAB_STATES;
  scrollIntoViewProductSize_Id?: number;
}) {
  const [tabState, setTabState] = useState<TAB_STATES>(
    exhibitor_tab ?? 'VIDEO'
    // exhibitor_tab ?? 'PRODUCTS'
  );
  const [scrollIntoViewProductSizeId, setScrollIntoViewProductSizeId] =
    useState(scrollIntoViewProductSize_Id);

  const tabOnClick = (tab: TAB_STATES) => {
    setTabState(tab);
  };

  const showProductsAndScrollToProductSize = (productSizeId) => {
    setTabState('ORDER');
    setScrollIntoViewProductSizeId(productSizeId);
  };

  return (
    <ProductListProvider>
      <ProductsFilterProvider>
        <Modal1
          show={isOpen}
          onHide={() => {
            onClose();
          }}
          className={styles.ExhibitorPopup}
        >
          {!exhibitor ? (
            <div className={'py-5 text-center'}>
              <LoadingSpinner />
            </div>
          ) : (
            <div className={styles.ExhibitorPopup}>
              <div className={styles.headerSection}>
                <div
                  className={styles.logoWrapper}
                  onClick={() => tabOnClick('VIDEO')}
                >
                  {exhibitor.organiser ? (
                    <LogoImage
                      noNavigation
                      height={'40px'}
                      className="mb-3"
                    />
                  ) : (
                    <img src={exhibitor.logo_image_url} alt={exhibitor.name} />
                  )}
                </div>

                <nav className={styles.tabNav}>
                  {exhibitor.organiser ? (
                    <>
                      <TabButton
                        active={tabState === 'FEEDBACK'}
                        onClick={() => tabOnClick('FEEDBACK')}
                        text={'Give feedback'}
                        icon={faComment}
                      />
                      <TabButton
                        active={tabState === 'AWARDS'}
                        onClick={() => tabOnClick('AWARDS')}
                        text={'NaskorSports Awards'}
                        icon={faAward}
                      />
                    </>
                  ) : (
                    <>
                      {exhibitor.has_highlights && (
                        <TabButton
                          active={tabState === 'HIGHLIGHT'}
                          onClick={() => tabOnClick('HIGHLIGHT')}
                          text={'Highlights'}
                          icon={faStar}
                        />
                      )}
                      {exhibitor.has_new_product_attributes && (
                        <TabButton
                          active={tabState === 'NEW'}
                          onClick={() => tabOnClick('NEW')}
                          text={'New products'}
                          icon={faSparkles}
                        />
                      )}
                      <TabButton
                        active={tabState === 'ORDER'}
                        onClick={() => tabOnClick('ORDER')}
                        text={'Place order'}
                        icon={faCartShopping}
                      />
                      {exhibitor.has_samples && (
                        <TabButton
                          active={tabState === 'SAMPLES'}
                          onClick={() => tabOnClick('SAMPLES')}
                          text={'Free samples'}
                          icon={faGift}
                        />
                      )}
                      <TabButton
                        active={tabState === 'FEEDBACK'}
                        onClick={() => tabOnClick('FEEDBACK')}
                        text={'Give feedback'}
                        icon={faComment}
                      />
                      {exhibitor.has_media_files && (
                        <TabButton
                          active={tabState === 'MEDIA'}
                          onClick={() => tabOnClick('MEDIA')}
                          text={'Media center'}
                          icon={faPhotoFilm}
                        />
                      )}
                      {/* <TabButton
                        active={tabState === 'PRODUCTS'}
                        onClick={() => tabOnClick('PRODUCTS')}
                        text={'New Place order'}
                        icon={faCartShopping}
                      /> */}
                    </>
                  )}
                </nav>
              </div>
              <Row className="mt-3">
                <Col>
                  {tabState == 'VIDEO' && (
                    <>
                      <Video exhibitor={exhibitor} />
                    </>
                  )}
                  {tabState == 'HIGHLIGHT' && (
                    <>
                      <Highlight exhibitor={exhibitor} />
                    </>
                  )}
                  {tabState == 'NEW' && (
                    <>
                      <NewProduct
                        exhibitor={exhibitor}
                        showProductsAndScrollToProductSize={
                          showProductsAndScrollToProductSize
                        }
                      />
                    </>
                  )}

                  {/* {tabState == 'PRODUCTS' && (
                    <VtsProducts exhibitor={exhibitor} />
                  )} */}

                  {tabState == 'ORDER' && (
                    <VtsProducts exhibitor={exhibitor} />
                  )}
                  {tabState == 'FEEDBACK' && (
                    <>
                      <Feedback exhibitor={exhibitor} />
                    </>
                  )}
                  {tabState == 'MEDIA' && (
                    <>
                      <MediaCenter exhibitor={exhibitor} />
                    </>
                  )}
                  {tabState == 'SAMPLES' && (
                    <>
                      <Samples exhibitor={exhibitor} />
                    </>
                  )}
                </Col>
              </Row>
              {tabState == 'AWARDS' && <AwardYearAwardCategories />}
            </div>
          )}
        </Modal1>
      </ProductsFilterProvider>
    </ProductListProvider>
  );
}
